import {
  IPayerResponse,
  IRequirementResponse
} from "@wingspanhq/payments/dist/interfaces";
import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users/dist/lib/interfaces";
import { IdentityVerificationRequestStatus } from "@wingspanhq/users/dist/lib/interfaces/identityVerificationRequest";
import { PayeeTaxDocumentSharePermission } from "@wingspanhq/payments/dist/interfaces/payerPayee";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import { WSPosterProps } from "@wingspanhq/fe-component-library";

export const payerIdentityVerificationRenderCardDescription = (
  requirement: IRequirementResponse,
  identityVerificationRequest: IIdentityVerificationRequestResponse | undefined,
  payer: IPayerResponse | undefined
) => {
  const isInfoShared =
    payer?.payeeOwnedData.shareTaxDocument ===
    PayeeTaxDocumentSharePermission.Allow;

  const payerNames = wsName({
    user: payer?.user!,
    member: payer?.member,
    payeeOwnedData: payer?.payeeOwnedData
  });

  const payerName = payerNames.getResolvedName();

  const descriptions: Record<IdentityVerificationRequestStatus, WSPosterProps> =
    {
      [IdentityVerificationRequestStatus.Pending]: isInfoShared
        ? {
            type: "people",
            title:
              "Your payer has requested an ID verification to be completed",
            description:
              "Click start to open the ID verification in a pop-up. When you have uploaded the acceptable documents and the verification process is complete, the results will be shown here."
          }
        : {
            type: "people",
            title:
              "Your payer has requested an ID verification to be completed",
            description: `To proceed with verification process, you need to consent to share your ID verification information with ${payerName}.`
          },
      [IdentityVerificationRequestStatus.Complete]: {
        type: "done",
        title: "Your ID verification is complete",
        description:
          "Your identity verification and biometrics matching is complete. Your payer will also be notified."
      },
      [IdentityVerificationRequestStatus.Failed]: {
        type: "people",
        title: "Something went wrong with your ID verification",
        description: "Please contact your payer to resolve the issue."
      }
    };

  return mapStatusesToCardDetails<IdentityVerificationRequestStatus>({
    requirement,
    documentStatus:
      identityVerificationRequest?.status ||
      IdentityVerificationRequestStatus.Pending,
    documentStatuses: descriptions,
    pendingApprovalStatus: {
      type: "people",
      title: "Your ID verification is waiting approval",
      description:
        "Your identity verification and biometrics matching is waiting approval from your payer."
    },
    approvedStatus: {
      type: "people",
      title: "Your ID verification was approved",
      description:
        "Your identity verification and biometrics matching was approved by the client. There is no further action to take at the moment."
    },
    rejectedStatus: {
      type: "people",
      title: "Your ID verification was rejected",
      description:
        "Your identity verification and biometrics matching was rejected by the client. There is no further action to take at the moment. If you think this is a mistake, please contact your payer to resolve the issue."
    }
  });
};
